import React, { createContext, useState, useEffect } from 'react';

/**
 * Language Context
 * Manages application language state (Korean/English)
 * Persists language preference in localStorage
 */
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to 'ko'
  const [language, setLanguageState] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'ko';
  });

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Language setter function
  const setLanguage = (newLanguage) => {
    if (newLanguage === 'ko' || newLanguage === 'en') {
      setLanguageState(newLanguage);
    }
  };

  // Toggle between languages
  const toggleLanguage = () => {
    setLanguage(language === 'ko' ? 'en' : 'ko');
  };

  // Get translated text from data object
  const getText = (data, key, keyEn) => {
    if (!data) return '';
    return language === 'ko' ? data[key] : data[keyEn || `${key}En`];
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    getText,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
